import {
  GET_PROFILE,
  GET_TOKEN,
  GET_IS_MEMBER,
  GET_IS_INTERN_REQUEST,
} from "../action/profileAction";

const initState = {
  profile: "",
  token: "",
  isMember: false,
  isInternRequest: false,
};

const profileReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload.profile,
      };
    case GET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case GET_IS_MEMBER:
      return {
        ...state,
        isMember: action.payload.isMember,
      };
    case GET_IS_INTERN_REQUEST:
      return {
        ...state,
        isInternRequest: action.payload.isInternRequest,
      };

    default:
      break;
  }

  return state;
};

export default profileReducer;
